<template>
  <nav class="menu">
    <ul>
      <li
        v-for="item in items"
        :key="item.to"
        :class="{ 'disable-on-mobile': item.disableOnMobile }"
      >
        <ButtonHeaderSubscribe v-if="item.type === 'subscribe'" v-bind="item" />
        <ButtonHeaderNav v-else v-bind="item" />
      </li>
    </ul>
  </nav>
</template>
<script lang="ts" setup>
const { items } = useNavigationMain('header');
</script>
<style lang="scss" scoped>
ul {
  --color_border: var(--color_secondary_light);
  --color_background: var(--color_neutral_25);

  display: flex;
  align-items: center;
  justify-content: center;
  height: auto;
  border: 0;
  gap: var(--gap_xl);
  @include above('xl') {
    gap: var(--gap_xxl);
  }
  @include mobile {
    display: none;
  }
}
</style>
